import type React from 'react';
import type { ReactNode } from 'react';
import { Component } from 'react';
import IntegrationCommunication from 'services/integration-communication';
import { sentryCaptureError } from 'services/sentry/capture';

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    sentryCaptureError(error, {
      extra: errorInfo as unknown as Record<string, unknown>,
    });
    IntegrationCommunication.sendMessage({
      id: 'reInitCashier',
    });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return null;
    }
    return children;
  }
}

export default ErrorBoundary;
